import React, { useEffect, useRef, useState } from "react";
import { RangeSlider } from "rsuite";
import "./slider.scss";
import useDebounce from "../../../utils";

const Slider = (props: any) => {
	const leftPivot = props.leftPivot >= 120 ? 120 : props.leftPivot;
	const rightPivot = props.leftPivot >= 120 ? 120 : props.rightPivot;
	const rebateData = props.rebate;
	const view = props?.view;
	const points = [
		80, 85, 90, 95, 98.38, 100, 102.5, 105, 107.5, 110, 112.5, 115, 117.5,
		120, 122.5,
	];

	const didMount: any = useRef(false);

	const [value, setValue] = useState<[number, number]>([
		leftPivot <= 75 ? 77.5 : leftPivot,
		rightPivot <= 75 ? 77.5 : rightPivot < 80 ? leftPivot : rightPivot,
	]);

	useEffect(() => {
		console.log(value, "va123");
		setValue([
			leftPivot <= 75 ? 77.5 : leftPivot,
			rightPivot <= 75 ? 77.5 : rightPivot < 80 ? leftPivot : rightPivot,
		]);
	}, [props.rightPivot, rebateData]);

	const debouncedSearch = useDebounce(value[1], 300);
	useEffect(() => {
		if (didMount.current) props.handleSliderChange(debouncedSearch);
		else {
			didMount.current = true;
		}
	}, [debouncedSearch, didMount]);

	const handleSliderChange = (newValue: [number, number]) => {
		if (view != "trendView") {
			props.sliderChange.current = true;
			setValue([...newValue]);
		}
	};

	const renderMark = (markValue: number) => {
		if ([75].includes(markValue)) {
			return (
				<div style={{ marginTop: "-57px", marginLeft: "0px" }}>
					<span
						style={{
							marginLeft: "14px",
							display: "inline-block",
							transform: "translateX(-50%)",
						}}
					>
						0%
					</span>
					<div className="devider">|</div>
				</div>
			);
		} else if (
			leftPivot > 0 &&
			leftPivot <= 75 &&
			[77.5].includes(markValue)
		) {
			return (
				<div style={{ marginTop: "-57px", marginLeft: "-4px" }}>
					<span
						style={{
							marginInline: "7px",
							display: "inline-block",
							transform: "translateX(-50%)",
						}}
					>
						{leftPivot}%
					</span>
					<div className="devider">|</div>
				</div>
			);
		} else if ([120].includes(markValue)) {
			return (
				<div style={{ marginTop: "-57px", marginLeft: "-4px" }}>
					<span
						style={{
							marginInline: "7px",
							display: "inline-block",
							transform: "translateX(-50%)",
						}}
					>
						120+%
					</span>
					<div className="devider">|</div>
					<div className="" style={{ marginTop: "2.5vh", fontSize:'1.3vh' }}>
						{Number(
							`${rebateData?.[`${markValue.toFixed(2)}%`] * 100}`
						).toFixed(2) + "%"}
					</div>
				</div>
			);
		} else if (points.includes(markValue)) {
			return (
				<div style={{ marginTop: "-57px", marginLeft: "-4px" }}>
					<span
						style={{
							marginInline: "7px",
							display: "inline-block",
							transform: "translateX(-50%)",
						}}
					>
						{markValue}%
					</span>
					<div className="devider">|</div>
					<div className="" style={{ marginTop: "2.5vh", fontSize:'1.3vh' }}>
						{Number(
							`${rebateData?.[`${markValue.toFixed(2)}%`] * 100}`
						).toFixed(2) + "%"}
					</div>
				</div>
			);
		}
		return null;
	};

	return (
		<>
			<div className="slider-wrapper   ">
				<div className="flex flex-col static-block">
					<table className="common-table-ui niaSimulatorSliderTable !border-0">
						<thead>
							<tr>
								<th>Vendor</th>
								<th>
									Base <br /> Rebate
								</th>
							</tr>
						</thead>
						<tbody className="!border-b-0">
							<tr className="!border-b-0">
								<td className="!border-b-0">
									{rebateData?.master_vendor_name?.length > 15
										? rebateData?.master_vendor_name.slice(
												0,
												15
										  ) + "..."
										: rebateData?.master_vendor_name}
								</td>
								<td className="text-center left-2 !border-b-0">
									{(rebateData?.rebate_base * 100).toFixed(2)}
									%
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<RangeSlider
					min={75}
					defaultValue={value}
					step={2.5}
					max={122.5}
					graduated
					progress
					value={value}
					handleClassName={`triangle-handle ${
						props.leftPivot > 120 ? "hide-greenHandle" : ""
					}`}
					onChange={handleSliderChange}
					constraint={([start, end]) => {
						const l = leftPivot <= 75 ? 77.5 : leftPivot;
						return start == l && end > l && end >= 80;
					}}
					renderMark={renderMark}
					renderTooltip={(markValue: any) => {
						if ([75].includes(markValue)) {
							return <span>0%</span>;
						} else if (
							leftPivot <= 75 &&
							[77.5].includes(markValue)
						) {
							return <span>{leftPivot}%</span>;
						} else if (
							[120].includes(markValue) ||
							[122.5].includes(markValue)
						) {
							return <span>120+%</span>;
						} else if (points.includes(markValue)) {
							return <span>{markValue}%</span>;
						} /* (leftPivot > 75) */ else {
							return <span>{leftPivot}%</span>;
						}
					}}
					style={{ width: "100%"}}
			        className="m-4 niaSimulatorSliderRangeWrapper"
				/>
			</div>
		</>
	);
};

export default Slider;
